export enum ApplicationEvent {
    INIT = 'onApplicationInit',
    LOADING_COMPLETE = 'onApplicationLoadingComplete',
}
